module.exports = __webpack_public_path__ + "static/media/financeTermIco.81c772e1.svg";